import { $api } from '@service/RequestService';
import { timeStampToDate } from '@utils/index';
import { useQuery } from 'react-query';

import { contractConstants, contractModels } from '..';

export const useOnlineContractClientSignatureId = (props: { contractId?: number }) =>
  useQuery<contractModels.IOnlineContractClientSignatureId>({
    queryKey: [contractConstants.queryKeys.ONLINE_CONTRACT_CLIENT_SIGNATURE, props?.contractId],
    queryFn: async () => {
      const res = await $api.get(`/v1/online-contract/client-signature/${props?.contractId}`);

      const data: contractModels.IOnlineContractClientSignatureId = res?.data?.data;

      return data
        ? {
            ...data,
            updateDate: timeStampToDate({
              date: data?.updateDate,
              timeStamp: data?.updateTimestamp
            }),
            signatureLinkDate: timeStampToDate({
              date: data?.signatureLinkDate,
              timeStamp: data?.signatureLinkTimestamp
            })
          }
        : data;
    },
    enabled: !!props?.contractId
  });
